// extracted by mini-css-extract-plugin
module.exports = {"leadGenerationLanding":"LeadGenerationView_leadGenerationLanding__6PQ0u"};